interface CardDetailsProps {
  recipient: "Consultor da concessionária" | "Volks|total" | "Gestor de Frotas" | "Não identificado";
  date: string;
  vehicleChassis?: string;
  customerName?: string;
}

const CardDetails = ({ recipient, date, vehicleChassis, customerName }: CardDetailsProps) => {
  return (
    <div className="space-y-2 mb-3">
      <div className="flex justify-between">
        <span className="text-size-14">Destinatário:</span>
        <span className="text-size-14">{recipient}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-size-14">Data:</span>
        <span className="text-size-14">{date}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-size-14">Chassi:</span>
        <span className="text-size-14">{vehicleChassis}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-size-14">Cliente:</span>
        <span className="text-size-14">{customerName}</span>
      </div>
    </div>
  );
};

export default CardDetails;



